import { getDraftsListRequestSchema } from "@/lib/schemas/cat/drafts-list";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";
import type { GetDraftsListResponse } from "@/types/cat/drafts";

const DRAFTS_LIST_ENDPOINT = "/api/cat/drafts";

export const invalidateDraftsListQuery =
  createInvalidateQuery(DRAFTS_LIST_ENDPOINT);

export const useDraftsListQuery = createQueryHook<GetDraftsListResponse>(
  DRAFTS_LIST_ENDPOINT,
  getDraftsListRequestSchema,
);

export function draftsListQueryOptions(hasLockedDraft: boolean) {
  return {
    refetchInterval: () =>
      typeof document !== "undefined" && document.visibilityState === "visible"
        ? hasLockedDraft
          ? 15_000
          : 30_000
        : false,
    refetchOnWindowFocus: true,
  } as const;
}
